export let DropFileError = /*#__PURE__*/function (DropFileError) {
  DropFileError["TOO_LARGE"] = "file-too-large";
  DropFileError["TOO_SMALL"] = "file-too-small";
  DropFileError["TOO_MANY_FILES"] = "too-many-files";
  DropFileError["INVALID_TYPE"] = "file-invalid-type";
  return DropFileError;
}({});